export default "__VITE_ASSET__bf11ebdf__"